import { render, staticRenderFns } from "./LeaveBalanceAdjNew.vue?vue&type=template&id=4d1b1304"
import script from "./LeaveBalanceAdjNew.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceAdjNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports